// Application
import { tracking } from 'constants/index'
import { ContactType } from 'typings'

interface Props {
    isPreRegisterUser: boolean
    biologicalSex?: string
    contactType: ContactType
}

const getAnalyticsContactType = (type: ContactType): ContactType => {
    const { EMAIL, WHATSAPP, SMS } = ContactType

    if ([EMAIL, WHATSAPP].includes(type)) {
        return ContactType[type]
    }
    return SMS
}

export const trackData = ({ isPreRegisterUser, biologicalSex, contactType }: Props) => ({
    vpageview: {
        event: tracking.CADASTRO_SUCESSO.EVENT,
        href: tracking.CADASTRO_SUCESSO.HREF,
        path: isPreRegisterUser ? tracking.PATH.MDM : tracking.PATH.NEW,
        sex: biologicalSex,
        register_validation: getAnalyticsContactType(contactType),
    },
    stepFunnel: {
        event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
        steps: isPreRegisterUser ? tracking.STEPS.MDM_CADASTRO_CONCLUIDO : tracking.STEPS.NEW_CADASTRO_CONCLUIDO,
    },
})
